<template>
  <h3 v-if="message">
    <b>{{ message }}</b>
  </h3>
  <section v-else class="employee-work-time-controls-list">
    <employee-work-time-controls-list-item
      class="employee-work-time-controls employee-work-time-controls-list__item"
      v-bind:key="`employee-work-time-controls:employees:${id}`"
      v-for="{
        description,
        id,
        name,
        nextAction,
        isAssistant,
        doctorsToAssist,
        doctorAssist,
      } in employees"
      v-bind:name="name"
      v-bind:employee-id="id"
      v-bind:description="description"
      v-bind:next-action="nextAction"
      v-bind:is-assistant="isAssistant"
      v-bind:doctors-to-assist="doctorsToAssist"
      v-bind:doctor-assist="doctorAssist"
      v-on:employee-counter-start="onEmployeeStart"
      v-on:employee-counter-stop="onEmployeeStop"
    />
  </section>
</template>
<script>

import EmployeeWorkTimeControlsListItem from '@/components/EmployeeWorkTimeControlsListItem.vue';

/**
 * @description Список сотрудников для управлением рабочим временем.
 * @type {Vue}
 */
export default {
  components: { EmployeeWorkTimeControlsListItem },
  methods: {
    /**
     * @description Обработать запуск счетчика сотрудника.
     * @param {number}      employeeId             Идентификатор сотрудника.
     * @param {number|null} selectedDoctorToAssist Идентификатор доктора на ассистирование.
     * @param {string}      date                   Дата запуска.
     * @returns {void}
     */
    onEmployeeStart(employeeId, selectedDoctorToAssist, date) {
      this.$emit('employee-counter-start', employeeId, selectedDoctorToAssist, date);
    },
    /**
     * @description Обработать остановку счетчика сотрудника.
     * @param {number} employeeId Идентификатор сотрудника.
     * @param {string} date       Дата остановки.
     * @returns {void}
     */
    onEmployeeStop(employeeId, date) {
      this.$emit('employee-counter-stop', employeeId, date);
    },
  },
  name: 'EmployeeWorkTimeControlsList',
  data() {
    return {
      selectedDoctorToAssist: null,
    };
  },
  props: {
    employees: {
      required: true,
      type: Array,
    },
    message: {
      default: () => '',
      type: String,
    },
  },
};
</script>
<style lang="scss" scoped>
@use "@/scss/buttons";
.employee-work-time-controls {
  &-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    &__item {
      position: relative;
      display: grid;
      grid-template-columns: 30% 1fr;
      align-items: center;
      column-gap: 65px;
      padding-top: 28px;
      &::before,
      &::after {
        position: absolute;
        left: 0;
        margin-left: -27px;
        width: calc(100% + 54px);
        height: 1px;
        background-color: #c2cfe0;
      }
      &::before {
        content: '';
        top: 0;
      }
      &:last-child::after {
        content: '';
        bottom: -29px;
      }
    }
  }
  &__desc {
    color: var(--unfocus-color);
    font-size: .825rem;
  }
  &__head {
    flex: 0 1 min(12rem, 100%);
    font-size: 1.125rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &__start {
    @include buttons.btn-blue(65px, 32px, 14px);
  }
  &__stop {
    @include buttons.btn-transparent(65px, 32px, 14px);
  }
}

@media screen and (max-width: 600px) {
  .employee-work-time-controls {
    &-list {
      &__item {
        grid-template-columns: 1fr 1fr;
        column-gap: 35px;
      }
    }
  }
}
</style>
